<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    this.$wx.setConfig()
  }
}
</script>

<style>
  /* 分页点 */
  .swiper-pagination .swiper-pagination-bullet-active{
      background: #F93A42!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue